export const sidebarWidth = 258;
